<template>
  <div class="user-login">
    <div class="user-header">
      <img src="../assets/login1.png" @click="$router.replace('/')" alt="">
      <p>F F博客登录</p>
    </div>

    <div class="login-form">
      <div class="login-reg">
        <span :style="index == 0 ? '' : 'color: #1727b4; font-size: 16px;'">登录</span>
        <span @click="$router.replace('/register')" :style="index == 1 ? '' : 'color: #1727b4; font-size: 16px;'">去注册</span>
      </div>

      <div class="">
        <el-form status-icon :model="loginForm" ref="loginForm" label-width="100px" class="demo-dynamic">
          <el-form-item
            prop="email"
            label="邮箱"
            :rules="[
              { required: true, message: '请输入邮箱地址', trigger: 'blur' },
              { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
            ]"
          >
            <el-input v-model="loginForm.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            prop="pawd"
            :rules="{
              required: true, message: '密码不能为空', trigger: 'blur'
            }">
            <el-input type="password" v-model="loginForm.pawd" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item style="text-align: center;">
            <el-button style="width: 80%" type="primary" @click="submitLoginForm('loginForm')">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'user_login', //登录
    metaInfo () {
      return {
        title:'F F博客登录'
      }
    },

    data () {
      return {
        index: 0,
        isClick: true,
        loginForm: {
          email: '',
          pawd: ''
        }
      }
    },

    methods: {
      submitLoginForm (loginForm) {
        this.$refs[loginForm].validate((valid) => {
          if (valid) {
            if(!this.isClick) return false
            this.isClick = false
            this.$http.post('user/user_login', {obj: window.btoa(window.encodeURIComponent(JSON.stringify(this.loginForm)))}, true).then(res => {
              this.isClick = true
              if(res.data.code == 0){
                localStorage.setItem('userInfo', res.data.obj)
                this.$message.success(res.data.msg)
                this.$router.replace('/message')
              } else {
                this.$message.warning(res.data.msg)
              }
            }).catch(err => {
              this.isClick = true
              this.$message.error('网络有误！')
            })
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .user-login {
    .user-header {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      font-size: 40px;
      font-weight: bold;
      color: #000;
      img {
        margin-right: 20px;
        border-radius: 50%;
        cursor: pointer;
        width: 80px;
        height: 80px;
      }
    }

    .login-form {
      background-color: #fff;
      padding: 30px 0;
      padding-right: 20px;
      box-sizing: border-box;
      margin-bottom: 100px;
      border-radius: 30px;
      box-shadow: 0px 0px 5px 0px #000;
      .login-reg {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        span {
          padding: 5px;
          font-size: 30px;
          color: #000;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/user_login.vue